/**
 * Created by Victor Rojo on 20/9/18.
 */
import {Component, Input, OnDestroy, ViewChild, TemplateRef} from '@angular/core';

import { TankWidget }               from "../../widget/Widget";
import { I18NService }              from "../../../shared/i18n/i18n.service";
import { WidgetService }            from "../../widget/Widget.service";
import {IPlaceDataChangeService} from "../../IPlaceDataChange.service";
import {WidgetStatusChangeAware} from "../base-widget/WidgetStatusChangeAware";
import {Tank} from "../../ipetrol/Tank";
import {TankDelivery} from "../../ipetrol/Tank";
import {BsModalService, BsModalRef} from "ngx-bootstrap/modal";
import {Globals} from '../../../globals';

@Component({
  selector: 'tank',
  templateUrl: './Tank.component.html',
  styleUrls: ['./Tank.component.css']
})
export class TankComponent extends WidgetStatusChangeAware{
  volumePercentage:number = 0;
  volumeUnit: String = "L";
  strokeDasharray:string = "";
  private deliveriesLog = false;
  tableMessages: any;
  subscriptions: any[] = [];
  modalRef: BsModalRef;
  @ViewChild('tankDeliveryTemplate', { static: true }) tankDeliveryTemplate: TemplateRef<any>;

  constructor(private i18nService: I18NService,
              private widgetService: WidgetService,
              private modalService: BsModalService,
              private iPlaceDataChangeService1: IPlaceDataChangeService,
              private globals: Globals) {
    super(iPlaceDataChangeService1);

    this.tableMessages = {};
    this.tableMessages.emptyMessage = this.i18nService.get("noDataToDisplay");
    this.tableMessages.totalMessage = this.i18nService.get("total");
    this.tableMessages.selectedMessage = this.i18nService.get("selected");

    this.subscriptions.push(this.iPlaceDataChangeService1.tankChange$.subscribe( (tank:Tank) => {
      let tankWidget = this._widget as TankWidget;
      if ( tank.tankId == tankWidget.tankId ) {
        tankWidget.tankName = tank.name;
        tankWidget.temperature = tank.temperature;
        tankWidget.capacity = tank.capacity;
        tankWidget.productVolume = tank.productVolume;
        tankWidget.productHeight = tank.productHeight;
        tankWidget.waterVolume = tank.waterVolume;
        tankWidget.waterHeight = tank.waterHeight;
        tankWidget.updated = tank.updated;
        this.updateValues(tankWidget);
      }
    }));

    this.subscriptions.push(this.iPlaceDataChangeService1.tankDeliveryChange$.subscribe( (tankDelivery:TankDelivery) => {
      let widgetTank = this._widget as TankWidget;
      if ( tankDelivery.tankId == widgetTank.tankId ) {
        widgetTank.tankDeliveries.push(tankDelivery);
        widgetTank.tankDeliveries = widgetTank.tankDeliveries
          .sort( (a,b) => a.updated - b.updated )
          .slice(0,10);
      }
    }));
    this.setVolumeUnit();
  }

  private setVolumeUnit() {
    if (this.globals.tenant === "ecuador") {
      this.volumeUnit = "gal";
    }
  }

  get widget(): TankWidget {
    return this._widget as TankWidget;
  }

  @Input()
  set widget(tankWidget: TankWidget) {
    this._widget = tankWidget;
    this.updateValues(tankWidget);
  }

  private updateValues(tankWidget: TankWidget) {

    this.volumePercentage = tankWidget.capacity ? tankWidget.productVolume * 100 / tankWidget.capacity : 0;
    this.strokeDasharray = this.volumePercentage + ", 100"
  }

  showDeliveriesLog(){
    this.modalRef = this.modalService.show(this.tankDeliveryTemplate);

  }

  hideDeliveriesLog(){
    this.deliveriesLog = false;
  }

  public ngOnDestroy(): void {
    super.ngOnDestroy();
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}
